module.exports = __webpack_public_path__ + "img/home-face.0399b522.svg";